import React from 'react';
import { Unsubscribe } from 'redux';
import functionHelper from '../../../infrastructure/helpers/functions/function/functionHelper';
import actions from '../../../store/actions';
import store from '../../../store/store';
import Operand from '../../../types/functions/Operand/Operand';
import operandDisplayHelper from '../../../infrastructure/helpers/functions/operand/operandDisplayHelper';
import CustomDataSourceFields from '../../../types/report/CustomDataSourceFields';
import getArgument from '../Condition/ContitionItem/getArgument';
import copyArray from '../../../infrastructure/helpers/common/copyArray';
import { ReactComponent as RemoveIcon } from '../../../components/Common/BootstrapIcons/trash.svg';
import ArgumentDefinition from '../../../types/functions/ArgumentDefinition';
import Modal from '../../Common/Modal/Modal';
import MoreArgumentsState from './MoreArgumentsState';
import ReportLogicLocation from '../../../types/functions/Location/ReportLogicLocation';
import FunctionDefinition from '../../../types/functions/FunctionDefinition';
import copyObject from '../../../infrastructure/helpers/common/copyObject';
import './MoreArgumentsModal.scss';

interface State extends MoreArgumentsState {
    showArgumentsModal: boolean,
    initialArguments: Operand[],
    error: string | null
}

class MoreArgumentsModal extends React.Component<any, State> {

    private unsubscribe: Unsubscribe | undefined;

    private minArgumentsCount = 0;
    private maxArgumentsCount = 0;
    private tooltips = [] as string[];
    private args: JSX.Element[] = [];
    private definition: FunctionDefinition = {} as FunctionDefinition;

    constructor(props: any) {
        super(props);

        this.state = {
            showArgumentsModal: false,
            initialArguments: [],
            error: null,
            argumentIndexes: [],
            customDataSourceFields: {} as CustomDataSourceFields,
            dataSources: [],
            dictionaries: [],
            disabled: false,
            functions: [],
            globalFunctions: [],
            lookups: [],
            onClick: () => { },
            operand: {} as Operand,
            operandNumber: 0,
            reportConfigType: '',
            reportFields: [],
            selectorNumber: 0,
            variables: [],
            aggregations: [],
            cases: [],
            location: {} as ReportLogicLocation

        }
        this.onCloseArgumentsModal = this.onCloseArgumentsModal.bind(this);
        this.onSaveArgumentsModal = this.onSaveArgumentsModal.bind(this);
        this.onAddArgument = this.onAddArgument.bind(this);
        this.onRemoveArgument = this.onRemoveArgument.bind(this);
        this.onStateChange = this.onStateChange.bind(this);
    }

    componentDidMount(): void {
        this.unsubscribe = store.subscribe(this.onStateChange);
    }

    componentWillUnmount(): void {
        (this.unsubscribe as Unsubscribe)();
    }

    setNestedArgument(root: Operand, indices: number[], newOperand: Operand): Operand {
        if (indices.length === 0) {
            return newOperand;
        }

        const args = root.arguments ?? [];

        if (indices.length === 1) {

            const newArguments = [...args];

            newArguments[indices[0]] = newOperand;
            
            return { ...root, arguments: newArguments };
        }

        const [head, ...tail] = indices;

        if (!args[head]) {
            return root;
        }

        const newArguments = [...args];
        newArguments[head] = this.setNestedArgument(newArguments[head], tail, newOperand);

        return { ...root, arguments: newArguments };
    }

    onStateChange() {
        let state = store.getState();

        if (state.action === actions.moreArgumentsModal.open) {
            this.setState({ showArgumentsModal: true, ...state.moreArgumentsState });
        }

        if (state.action === actions.operandModal.change && state.operandModalChange.isOpen === false
            && !state.operandModalChange.error
            && this.state.showArgumentsModal && this.state.operand?.arguments) {

            const savedState = state.operandModalSave;
            if (!savedState?.operand) {
                return;
            }

            const currentArgumentIndexes = this.state.argumentIndexes || [];
            const savedArgumentIndexes = savedState.location?.argumentIndexes || [];

            if (!currentArgumentIndexes.every((x, i) => x === savedArgumentIndexes[i])) {
                return;
            }

            const relativeArgumentIndexes = savedArgumentIndexes.slice(currentArgumentIndexes.length);

            let operand = copyObject(this.state.operand);

            let newOperand = this.setNestedArgument(operand, relativeArgumentIndexes, savedState.operand);

            this.setState({ operand: newOperand });
        }

        if (state.action === actions.moreArgumentsModal.close) {
            this.setState({ showArgumentsModal: false });
        }
    }

    onCloseArgumentsModal() {
        this.setState({ showArgumentsModal: false });
    }

    validateArguments() {

        //start from 1 as on index 0 is the main function argument which is not defined here but on the main page
        for (var i = 1; i < (this.state.operand.arguments?.length || 0); i++) {
            const operand1Details = operandDisplayHelper.getOperandDetails(this.state.operand?.arguments?.[i] || {} as Operand, this.state.functions, this.state.globalFunctions, this.state.lookups,
                this.state.dictionaries, this.state.variables, this.state.dataSources, this.state.reportFields, {} as CustomDataSourceFields, this.state.reportConfigType, null);
            if (!operand1Details.isSetUp) {
                return 'Operand(s) not set up';
            }
        }

        return null;
    }

    onSaveArgumentsModal() {
        const error = this.validateArguments();
        if (!error) {
            store.dispatch({
                type: actions.moreArgumentsModal.save,
                payload: {
                    operand: this.state.operand,
                    argumentIndexes: this.state.argumentIndexes,
                    location: this.state.location
                }
            });
            this.setState({ error: null, showArgumentsModal: false });
        }
        else {
            this.setState({ error });
        }
    }

    getEmptyOperand() {
        return {
            operandType: '',
            fieldId: null,
            lookupNumber: null,
            variableNumber: null,
            reportFieldId: null,
            customDataSourceFieldId: null,
            selectorNumber: null,
            dataType: '',
            value: '',
            function: '',
            arguments: [],
            dictionaryNumber: null,
            functionNumber: null,
            aggregationNumber: 0
        };
    }

    onAddArgument() {

        var mainFunctionArgument = 1;

        if (this.maxArgumentsCount > (this.state.operand.arguments?.length || 0) - mainFunctionArgument) {

            let args = copyArray(this.state.operand.arguments || []);

            args.push(this.getEmptyOperand());

            let operand = copyObject(this.state.operand);

            operand.arguments = args;
            this.setState({ error: '', operand });
        }
        else {
            this.setState({ error: `Maximum arguments count is ${this.maxArgumentsCount}` });
        }
    }

    onRemoveArgument(index: number) {

        var mainFunctionArgument = 1;

        if (((this.state.operand.arguments?.length || 0) - mainFunctionArgument) > this.minArgumentsCount) {

            let args = copyArray(this.state.operand.arguments || []);

            let operandArgs = [];

            for (let i = 0; i < args.length; i++) {
                if (i !== index) {
                    operandArgs.push(args[i]);
                }
            }

            let operand = copyObject(this.state.operand);

            operand.arguments = operandArgs;
            this.setState({ error: '', operand });
        }
        else {
            this.setState({ error: `Minimum arguments count is ${this.minArgumentsCount}` });
        }
    }

    buildArgumentDescription(definition: ArgumentDefinition): string {

        return `${definition.name}: ${definition.allowedTypes.join(' | ')}`;
    };

    render() {

        if (!this.state.showArgumentsModal || !this.state.operand?.function) {
            return <></>;
        }

        if (this.state.operand?.function) {
            this.minArgumentsCount = this.state.operand.function ? functionHelper.getMinArrayArgumentCount(this.state.operand.function) : 0;
            this.maxArgumentsCount = this.state.operand.function ? functionHelper.getMaxArrayArgumentsCount(this.state.operand.function) : 0;

            this.tooltips = this.state.operand.function ?
                functionHelper.getArgumentDescriptions(this.state.operand.function, this.buildArgumentDescription)
                : [] as string[];

            this.definition = this.state.operand?.function ? functionHelper.getFunctionDefinition(this.state.operand.function) : {} as FunctionDefinition;

            this.args = (this.state.operand.arguments as Operand[])
                .map((x, i, arr) => getArgument(x, this.state.operandNumber, copyArray(this.state.argumentIndexes).concat([i]), this.tooltips[i],
                    this.state.functions, this.state.globalFunctions, this.state.lookups, this.state.dictionaries, this.state.variables, this.state.dataSources, this.state.reportFields,
                    this.state.customDataSourceFields, this.state.selectorNumber, this.state.onClick, i,
                    false, this.state.disabled,
                    this.state.reportConfigType,
                    this.state.location, this.state.cases, this.state.aggregations));
        }

        return (
            <div className='multiple-arguments'>
                <Modal containerClassName='z-index-0-important' state={{ title: 'Arguments', isOpen: this.state.showArgumentsModal, error: this.state.error }} close={this.onCloseArgumentsModal}>
                    <div className='flex-column arguments'>
                        {this.args.slice(this.definition.isMethod ? 1 : 0).map((item, index) => {
                            return <div key={item.key} className='flex-align-center display-flex align-center justify-content-start border-1px-solid-black margin-bottom-10px'>
                                {!this.state.disabled &&
                                    <button className="transparent-button" type="button" onClick={() => { this.onRemoveArgument(index + (this.definition.isMethod ? 1 : 0)); }}>
                                        <RemoveIcon />
                                    </button>
                                }
                                {item}
                            </div>
                        })
                        }
                    </div>
                    {!this.state.disabled &&
                        <div className='mt-3 mb-3 buttons-wrapper'>
                            <button className='btn btn-light' onClick={this.onAddArgument}>Add</button>
                            <button className='btn save-btn' onClick={this.onSaveArgumentsModal}>Save</button>
                        </div>
                    }
                </Modal>
            </div>
        )
    }
}

export default MoreArgumentsModal;